<div class="container-fluid content min-vh-100 p-0" *transloco="let t">
  <div class="container p-4">
    <div class="row">
      <div class="col-12 text-center">
        <h1>Loisirs à {{ placeTitle() }}</h1>
      </div>
    </div>
    @if (childPlaces().length > 0) {
      <section class="places">
        <div class="row align-items-center justify-content-center">
          <div class="col-12 text-center">
            <p>
              Loisirs à:
            </p>
            <ul class="my-2">
              @for (childPlace of childPlaces(); track childPlace.id) {
                <li>
                  <a [routerLink]="getPlaceUrl(childPlace)">{{ getPlaceName(childPlace) }}</a>
                </li>
              }
            </ul>
          </div>
        </div>
      </section>
    }
    <div class="row align-items-center justify-content-center">
      @if (activities().length > 0) {
        <div class="col-12 pt-4">
          <div class="card">
            <div class="card-header">Activités de loisir</div>
            <div class="card-body">
              <app-activities-preview
                [items]="activities()"
                [showState]="false"
                [showUnpublished]="false"
                [showHost]="true"
                [isPublic]="true">
              </app-activities-preview>
            </div>
          </div>
        </div>
      }
    </div>

    <section class="places my-2">
      <div class="row align-items-center justify-content-center">
        <div class="col-12 text-center">
          @if (showParent() && parentPlace()) {
            <a [routerLink]="getPlaceUrl(parentPlace())">
              <lucide-icon [img]="icons.back"></lucide-icon>
              Retour à
              {{ parentPlace()?.translation?.name }}
            </a>
          } @else {
            <a [routerLink]="routes.dashboard">
              <lucide-icon [img]="icons.back"></lucide-icon>
              Accueil
            </a>
          }
        </div>
      </div>
    </section>

  </div>
</div>
